import { render, staticRenderFns } from "./SyncExpenses.vue?vue&type=template&id=453f5472"
import script from "./SyncExpenses.vue?vue&type=script&lang=js"
export * from "./SyncExpenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports